export default "__VITE_ASSET__BF8$oYMr__"